import React from 'react';
import ActionsButton from '../buttons/ActionsButton/ActionsButton';
import classes from './BaseEditableItem.module.scss';

function BaseEditableItem(props) {
  const { mainTitle, secondaryTitle, description, editHandler, deleteHandler, disabled } = props;

  return (
    <section className={classes.mainWrapper}>
      <div className={`${classes.info} ${disabled ? classes.disabled : ''}`}>
        <span className={classes.mainTitle}>{mainTitle}</span>
        <span className={classes.secondaryTitle}>{secondaryTitle}</span>
        <span className={classes.description}>{description}</span>
      </div>
      <div className={classes.actions}>
        <ActionsButton activityName="edit" clickHandler={editHandler} />
        <ActionsButton activityName="delete" clickHandler={deleteHandler} />
      </div>
    </section>
  );
}

export default BaseEditableItem;
